import { Link } from 'react-router'
import logo from './images/logo.svg'
import instagram from './images/instagram.svg'

const NAV_LINKS = [
  { en: 'TOP', ja: 'トップ', href: '#top' },
  { en: 'OUR ROSES', ja: 'バラのセレクト', href: '#roses' },
  { en: 'PLAN', ja: 'プラン・料金', href: '#pricing' },
  { en: 'FLOWER VASE', ja: 'セット花器', href: '#vases' },
  { en: 'ABOUT', ja: '私たちについて', href: '#about' },
  { en: 'FAQ', ja: 'よくある質問', href: '#faq' },
]

const FOOTER_LINKS = [
  { label: 'FLOWER公式サイト', href: 'https://flowr.is' },
  { label: '運営会社', href: 'https://flowr.jp' },
  { label: 'プライバシーポリシー', href: '/policy' },
  { label: '利用規約', href: '/terms' },
  { label: '特定商取引法に基づく表示', href: '/commercial' },
]

export const DesktopSidebar: React.FC = () => {
  return (
    <aside className="hidden lg:flex flex-col justify-between sticky top-0 h-screen w-54 shrink-0 bg-white border-l border-black/10 px-8 py-10">
      <a href="/">
        <img src={logo} alt="FLOWER" className="w-32" />
      </a>

      <nav className="flex flex-col gap-6 pb-8">
        {NAV_LINKS.map(({ en, ja, href }) => (
          <a key={en} href={href} className="flex items-baseline gap-3 hover:opacity-60 transition-opacity">
            <span className="text-[12px] font-bold font-display text-[#111827]">{en}</span>
            <span className="text-[10px] text-black">{ja}</span>
          </a>
        ))}
        <Link reloadDocument to="/subscription/rose/mypage" className="flex items-baseline gap-3 hover:opacity-60 transition-opacity">
          <span className="text-[12px] font-bold font-display text-[#111827]">MYPAGE</span>
          <span className="text-[10px] text-black">マイページ</span>
        </Link>
      </nav>

      <div className="flex flex-col gap-6">
        <nav className="flex flex-col gap-2 text-[11px] text-black leading-normal">
          {FOOTER_LINKS.map(({ label, href }) => (
            <a key={label} href={href} className="hover:opacity-60 transition-opacity">
              {label}
            </a>
          ))}
        </nav>
        <a href="https://www.instagram.com/flowr_is/" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-black">
          <img src={instagram} alt="Instagram" className="w-9 h-9" />
        </a>
      </div>
    </aside>
  )
}
